import React, { memo } from "react";
import ReusableAccordian from "../ReusableAccordion";
import { pivotSill } from "./defaults";
import Choices from "../Choices";
import { Image } from "cloudinary-react";
import { RowLayout } from "../../util/accordianStyles";
import useSillSelector from "./useSillSelector";
import { addScrollElements } from "../AccordionWrapper/AccordianWrapper";

function PivotSillAccordian() {
  const { publicId, handleClick, sillStyle } = useSillSelector();

  return (
    <>
      {addScrollElements([
        "Sill Finish",
        "Sill Dam Finish",
        "Sill Type",
      ])}

      <ReusableAccordian
        accordionName="sill"
        heading="ADA Sill"
        secondaryHeading="Select ADA Sill type"
        colOrRow="col"
      >
        <RowLayout style={{ paddingBottom: 20 }}>
          {pivotSill.map((state) => (
            <div key={state.id} onClick={() => handleClick(state.label)}>
              <Choices
                label={state.label}
                variant={state.label === sillStyle ? "filled" : "outlined"}
                checkMark={state.label === sillStyle}
                wide={true}
              />
            </div>
          ))}
        </RowLayout>

        {sillStyle && (
          <Image
            cloudName="ag-millworks"
            secure="true"
            publicId={`/Sills/pivots/${publicId}`}
          />
        )}
      </ReusableAccordian>
    </>
  );
}

export default memo(PivotSillAccordian);
